import axios from "axios";
import { endpoints } from "./endpoints";
import store from "../store";
import { logout, updateToken } from "../store/slices/authSlice";
import {
  clearStoredAuth,
  getStoredRefreshToken,
  isRefreshTokenExpired,
  setStoredAccessToken,
  setStoredRefreshToken,
} from "../utils/authStorage";

let refreshPromise: Promise<string | null> | null = null;

export const forceLogout = () => {
  clearStoredAuth();
  store.dispatch(logout());
};

export const redirectToLogin = () => {
  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};

export const refreshAccessToken = async (): Promise<string | null> => {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = (async () => {
    const refreshToken = getStoredRefreshToken();

    if (!refreshToken || isRefreshTokenExpired()) {
      forceLogout();
      return null;
    }

    try {
      const response = await axios.post(
        endpoints.auth.refreshToken,
        { refresh_token: refreshToken },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const nextAccessToken = response.data?.access_token;
      const nextRefreshToken = response.data?.refresh_token;

      if (!nextAccessToken) {
        throw new Error("Access token missing in refresh response.");
      }

      setStoredAccessToken(nextAccessToken);
      if (nextRefreshToken) {
        setStoredRefreshToken(nextRefreshToken);
      }

      store.dispatch(updateToken(nextAccessToken));
      return nextAccessToken;
    } catch {
      forceLogout();
      return null;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
};
